exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-0fe6dc5e] {\n  background-color: #ff6c00 !important;\n  max-height: 75% !important;\n}\n", ""]);

// exports
